import React, { useState, useEffect } from 'react';
import { HiLogout } from '@react-icons/all-files/hi/HiLogout';
import { BsLockFill } from '@react-icons/all-files/bs/BsLockFill';
import SideBarAcceptedChallenges from './SideBarAcceptedChallenges';
import { useAuth } from '../auth/Auth';
import AgoraChat from '../chat/AgoraChat';
import { useLocation } from 'react-router-dom';
import { HOME_FEED, NEXT_CHALLENGE_ROUTE } from '../../constants/routes.constants';
import { isMobile } from 'react-device-detect';

const RightSideBar = (props) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [showLayout, setShowLayout] = useState(true);
  const { dependent, guardian, partner, school } = useAuth();
  // const [showLayout, setShowLayout] = useState(dependent?.profile?.group?.id ? true : school ? true : false);
  const [mobileDisplay, setMobileDisplay] = useState('');
  const [collapseClass, setCollapseClass] = useState(isMobile ? '' : showLayout ? '' : 'collapsse');
  const location = useLocation();

  const setCollapsse = () => {
    if (showLayout) {
      props.setRightCollapsse("right-collapsse");
      setCollapseClass('collapsse')
    }
    else {
      props.setRightCollapsse("");
      setCollapseClass('')
    }
    setShowLayout(!showLayout)
  }
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);
  useEffect(() => {
    if (isMobile && width < 1200) {
      if (props.leftCollapsse === "left-collapsse") {
        setMobileDisplay('none')
      } else {
        setMobileDisplay('')
      }
    }
  }, [props.leftCollapsse])

  return (
    <div style={{ display: mobileDisplay }} className={`flex-col-right ${collapseClass}`}>
      {school ? <AgoraChat isChatShow={props.isChatShow} challenge={props.challenge} /> :
        <>
          <div className='tree-house-chat'>
            <div className='tree-house-head'>
              <span className={`tree-house-ic ${collapseClass}`}>
                <a href='#' className='right-dropdown-btn' onClick={setCollapsse}> &nbsp; &nbsp;</a>
              </span>
              <span className='hide-on-toggle'>
                {props.isKidsRoom ? 'Tribe Camp Chat' : 'Treehouse Chat'}
              </span>
            </div>
            <div className='tree-house-body hide-on-toggle'>
              {guardian || dependent && !dependent.profile.is_activated || !props.isChatShow ||
                location.pathname === HOME_FEED || location.pathname === NEXT_CHALLENGE_ROUTE ?
                partner ?
                  <AgoraChat isChatShow={props.isChatShow} challenge={props.challenge} /> :
                  <div className="tree-house-enter-or-accept">
                    <span className='lock-ic'><BsLockFill /></span>
                    {props.isKidsRoom ? '' :
                      'Accept a challenge to chat to other creators when the expert opens the room'
                    }
                  </div>
                // <Chat />
                :
                <AgoraChat isChatShow={props.isChatShow} challenge={props.challenge} />
              }
            </div>
          </div>
          {!partner && !school && <SideBarAcceptedChallenges {...props} />}
        </>}
    </div>
  );
}

export default RightSideBar;
